import {
  type ApplicationDocumentUploadRequestBody,
  uploadApplicationDocument,
  waitForApplicationDocumentClean,
} from '@access-cms/api-client';

const PNG_DATA_URI_PREFIX = 'data:image/png;base64,';

function dataUrlToPngFile(dataUrl: string, filename = 'signature.png'): File {
  const base64Payload = dataUrl.startsWith(PNG_DATA_URI_PREFIX)
    ? dataUrl.slice(PNG_DATA_URI_PREFIX.length)
    : dataUrl.includes(',')
    ? dataUrl.split(',')[1]
    : dataUrl;

  if (!base64Payload) {
    throw new Error('Invalid signature image data');
  }

  const binary = atob(base64Payload);
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  return new File([bytes], filename, { type: 'image/png' });
}

/**
 * Upload a drawn signature PNG through staging → GuardDuty → final bucket.
 * Returns the CLEAN signature document id for attestation PATCH.
 */
export async function uploadDrawnSignatureImage(
  applicationId: string,
  imageDataUrl: string,
): Promise<{ signatureDocumentId: string }> {
  const file = dataUrlToPngFile(imageDataUrl);
  const body = {
    documentType: 'SIGNATURE',
    filename: 'signature.png',
    mimeType: 'image/png',
    size: file.size,
  } as unknown as ApplicationDocumentUploadRequestBody;

  const uploadResult = await uploadApplicationDocument({
    applicationId,
    body,
    file,
  });

  const cleanDocument = await waitForApplicationDocumentClean(applicationId, uploadResult.documentId);

  return { signatureDocumentId: cleanDocument.id ?? uploadResult.documentId };
}
